import Web3 from "web3"
const axios = require("axios").default
const { ethers } = require("ethers")

const ERC20 = require("../../../abi/lootbox/ERC20.json")
const BoxCollection = require("../../../abi/lootbox/LootboxCollection.json")
const LootboxSale = require("../../../abi/lootbox/LootBoxSale.json")
const NftCollection = require("../../../abi/lootbox/StandardUncappedNFTCollection.json")

const contracts = {
    swordsofblood: {
        network: "Polygon",
        chainId: 137,
        paymentToken: { address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", abi: ERC20 }, // USDT
        lootboxSale: { address: "0xE63902Bcae713880dbb99FC674490F770cEdb79B", abi: LootboxSale },
        boxCollection: {
            address: "0x264b550807D40685D9Df5507fB8f86B1e7DD694A",
            abi: BoxCollection,
            owner: "0x8142409931f554d99013de129cdDc70EA016d62d",
            symbol: "SOBFL"
        },
        nftCollection: {
            address: "0xe1F61fE6E0619cF65cD5123ae8b86db7B88BF02E",
            abi: NftCollection,
            owner: "0x8142409931f554d99013de129cdDc70EA016d62d",
            symbol: "SOBL"
        }
    }
    // swordsofblood: {
    //     network: "Mumbai",
    //     chainId: 80001,
    //     paymentToken: { address: "0xE097d6B3100777DC31B34dC2c58fB524C2e76921", abi: ERC20 }, // USDC
    //     lootboxSale: { address: "0x50b055C2C348e5cafac7b548AB37A720090720eD", abi: LootboxSale },
    //     boxCollection: { address: "0x11ac5b3Ab57b2755C28Cb4957208aEC34eF3dfdB", abi: BoxCollection },
    //     nftCollection: { address: "0x03AD931C53A3e0112f317dd09b8EdC13849d3bFd", abi: NftCollection }
    // }
}

const estimatePolygonGas = async () => {
    let feeData = null
    const MIN_PRIORITY_FEE = "30000000000"
    // get max fees from gas station
    try {
        const { data } = await axios({
            method: "get",
            url: "https://gasstation-mainnet.matic.network/v2"
        })

        if (data?.estimatedBaseFee) {
            if (ethers.utils.parseUnits(Math.ceil(data.fast.maxPriorityFee).toString(), "gwei").lte(MIN_PRIORITY_FEE)) {
                data.fast.maxPriorityFee = ethers.utils.formatUnits(MIN_PRIORITY_FEE, "gwei").toString()
            }
            feeData = {
                type: "0x2",
                wei: {
                    lastBaseFeePerGas: ethers.utils.parseUnits(Math.ceil(data.estimatedBaseFee).toString(), "gwei").toString(),
                    maxFeePerGas: ethers.utils
                        // baseFee * 2 + maxPriorityFee
                        .parseUnits(Math.ceil(data.estimatedBaseFee).toString(), "gwei")
                        .mul(ethers.BigNumber.from(2))

                        .add(ethers.utils.parseUnits(Math.ceil(data.fast.maxPriorityFee).toString(), "gwei"))
                        .toString(),
                    maxPriorityFeePerGas: ethers.utils.parseUnits(Math.ceil(data.fast.maxPriorityFee).toString(), "gwei").toString()
                }
            }
        }
        return feeData
    } catch (e) {
        console.log(e)
        // ignore
    }
}

const createTxOptions = async (wallet) => {
    const txOptions = { from: wallet.account }

    const gasData = await estimatePolygonGas()

    if (gasData) {
        txOptions.type = gasData.type
        txOptions.maxFeePerGas = gasData.wei.maxFeePerGas
        txOptions.maxPriorityFeePerGas = gasData.wei.maxPriorityFeePerGas
    }

    return txOptions
}

const getOpenedNFTs = async (wallet, setErrorMessageUserNFTs) => {
    const nCollection = []
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const nftCollection = new web3.eth.Contract(contracts.swordsofblood.nftCollection.abi, contracts.swordsofblood.nftCollection.address)
        const userNftCollection = await nftCollection.methods.getCollectionIds(wallet.account).call()

        //  getNfts
        for (let i = 0; i < userNftCollection.length; i++) {
            const tokenURI = await nftCollection.methods.tokenURI(userNftCollection[i]).call()
            const metadata = await fetchImageFromMetadata(tokenURI)
            const imageUri = String(metadata?.image).replace("ipfs://", "https://nftstorage.link/ipfs/")
            // console.log(`tokenId: ${userNftCollection[i]}`, metadata)

            nCollection.push({
                id: nCollection.length,
                tokenId: userNftCollection[i],
                name: metadata?.name,
                description: metadata?.description,
                imgUrl: imageUri,
                attributes: metadata?.attributes,
                tokenURI: tokenURI
            })
        }

        // console.log("nCollection", nCollection)
        return nCollection
    } catch (error) {
        console.log(error)
        setErrorMessageUserNFTs(String(error))
    } finally {
    }
}

const getBoxForSale = async (wallet) => {
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)
        const lootboxSale = new web3.eth.Contract(contracts.swordsofblood.lootboxSale.abi, contracts.swordsofblood.lootboxSale.address)

        const boxOptionNames = await lootboxSale.methods.getBoxOptions().call()
        const options = []

        for (let i = 0; i < boxOptionNames.length; i++) {
            const item = await lootboxSale.methods.getBoxOptionDetails(boxOptionNames[i]).call()
            const meta = await fetchImageFromMetadata(item.metadata)
            const imageUri = String(meta?.image).replace("ipfs://", "https://nftstorage.link/ipfs/")
            options.push({
                id: i,
                type: meta?.attributes[0]?.value,
                name: item.name,
                maxSupply: item.max_supply,
                currentSupply: item.current_supply,
                itemsInBox: item.totalItems,
                imgUrl: imageUri,
                cost: Math.ceil(ethers.utils.formatUnits(item.price, 6)).toString() // decimals hardcoded for now
            })
        }

        return options
    } catch (error) {
        console.log(error)
    }
}

const getUserPaymentAllowance = async (wallet) => {
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)
        const paymentToken = new web3.eth.Contract(contracts.swordsofblood.paymentToken.abi, contracts.swordsofblood.paymentToken.address)

        const allowance = await paymentToken.methods.allowance(wallet.account, contracts.swordsofblood.lootboxSale.address).call()

        return ethers.utils.formatUnits(allowance.toString(), 6).toString()
    } catch (error) {
        console.log(error)
    }
}

const getUserPaymentBalance = async (wallet) => {
    try {
        // console.log("wallet", wallet)
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const paymentToken = new web3.eth.Contract(contracts.swordsofblood.paymentToken.abi, contracts.swordsofblood.paymentToken.address)
        // console.log("paymentToken", paymentToken)
        const symbol = await paymentToken.methods.symbol().call()
        // console.log("symbol", symbol)
        const decimals = await paymentToken.methods.decimals().call()
        // console.log("decimals", decimals)
        const balance = await paymentToken.methods.balanceOf(wallet.account).call()
        // console.log("balance", balance)

        return { symbol, decimals, balance: ethers.utils.formatUnits(balance.toString(), decimals).toString() }
    } catch (error) {
        console.log(error)
    }
}

const approveSpender = async (wallet, setDisableModalButtons, setShowConfirmLoading) => {
    setDisableModalButtons(true)
    setShowConfirmLoading(true)
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const paymentToken = new web3.eth.Contract(contracts.swordsofblood.paymentToken.abi, contracts.swordsofblood.paymentToken.address)

        const balance = await paymentToken.methods.balanceOf(wallet.account).call()

        const txOptions = await createTxOptions(wallet)
        const approveTx = await paymentToken.methods.approve(contracts.swordsofblood.lootboxSale.address, balance).send(txOptions)
        return approveTx
    } catch (error) {
        console.log(error)
    } finally {
        setDisableModalButtons(false)
        setShowConfirmLoading(false)
    }
}

const buyBox = async (wallet, boxName, amount, setDisableModalButtons, setShowConfirmLoading, setBuyTx) => {
    setDisableModalButtons(true)
    setShowConfirmLoading(true)
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const lootboxSale = new web3.eth.Contract(contracts.swordsofblood.lootboxSale.abi, contracts.swordsofblood.lootboxSale.address)
        const txOptions = await createTxOptions(wallet)
        const purchaseTx = await lootboxSale.methods.buyBox(boxName, amount).send(txOptions)

        setBuyTx(purchaseTx?.transactionHash)
    } catch (error) {
        console.log(error)
    } finally {
        setDisableModalButtons(false)
        setShowConfirmLoading(false)
    }
}

const getUserBoxCollection = async (wallet, setErrorMessagePurchased) => {
    const bxCollection = []
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const boxCollection = new web3.eth.Contract(contracts.swordsofblood.boxCollection.abi, contracts.swordsofblood.boxCollection.address)
        const userBoxCollection = await boxCollection.methods.getBoxCollectionIds(wallet.account).call()

        const lootboxSale = new web3.eth.Contract(contracts.swordsofblood.lootboxSale.abi, contracts.swordsofblood.lootboxSale.address)

        //  getBoxOptionDetails
        for (let i = 0; i < userBoxCollection.length; i++) {
            const box = await lootboxSale.methods.getBoxDetails(userBoxCollection[i]).call()
            const tokenURI = await boxCollection.methods.tokenURI(userBoxCollection[i]).call()
            const boxOption = await lootboxSale.methods.getBoxOptionDetails(box?.boxType).call()
            // console.log("BOX OPTION DETAILS:", boxOption)
            // console.log(`Box Id ${userBoxCollection[i]} details:`, box)
            const meta = await fetchImageFromMetadata(boxOption.metadata)
            const imageUri = String(meta?.image).replace("ipfs://", "https://nftstorage.link/ipfs/")
            let preOpened = false
            if (Number(box?.requestId) > 0) {
                const request = await lootboxSale.methods.viewRequest(box?.requestId).call()
                if (request?.fulfilled) {
                    preOpened = true
                }
            }
            bxCollection.push({
                id: bxCollection.length,
                boxId: box?.boxId,
                name: box?.boxType,
                preOpened: preOpened,
                opened: box?.opened,
                requestId: box?.requestId,
                imgUrl: imageUri,
                totalItems: boxOption?.totalItems,
                maxSupply: boxOption?.max_supply,
                currentSupply: boxOption?.current_supply,
                cost: Math.ceil(ethers.utils.formatUnits(boxOption?.price, 6)).toString(),
                tokenURI
            })
        }

        // console.log(bxCollection)
        return bxCollection
    } catch (error) {
        console.log(error)
        setErrorMessagePurchased(String(error))
    } finally {
    }
}

const preOpenBox = async (wallet, boxId, setShowConfirmLoading, setDisableModalButtons, setPreOpenTx) => {
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const lootboxSale = new web3.eth.Contract(contracts.swordsofblood.lootboxSale.abi, contracts.swordsofblood.lootboxSale.address)

        const txOptions = await createTxOptions(wallet)
        const preOpenTx = await lootboxSale.methods.preOpenBox(boxId).send(txOptions)

        setPreOpenTx(preOpenTx?.transactionHash)
        return preOpenTx
    } catch (error) {
        console.log(error)
    } finally {
        setShowConfirmLoading(false)
        setDisableModalButtons(false)
    }
}

const openBox = async (wallet, boxId, setShowConfirmLoading, setDisableModalButtons, setOpenTx) => {
    setDisableModalButtons(true)
    setShowConfirmLoading(true)
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const lootboxSale = new web3.eth.Contract(contracts.swordsofblood.lootboxSale.abi, contracts.swordsofblood.lootboxSale.address)

        const txOptions = await createTxOptions(wallet)
        const openTx = await lootboxSale.methods.openBox(boxId).send(txOptions)

        setOpenTx(openTx?.transactionHash)
        return openTx
    } catch (error) {
        console.log(error)
    } finally {
        setShowConfirmLoading(false)
        setDisableModalButtons(false)
    }
}

const fetchImageFromMetadata = async (metadata) => {
    try {
        const res = await fetch(metadata, {
            method: "GET"
        })
        const response = await res.json()
        // console.log("fetchImageFromMetadata", response)

        if (res.status !== 200) {
            // return setErrorFetchingMetadata(true)
        }

        return response
    } catch (err) {
        console.log(err)
    }
}

const lootBoxType = {
    "Basic Epic Box Test": "basic",
    "Basic Epic Box": "basic",
    "Medium Legendary Box Test": "medium",
    "Medium Legendary Box": "medium",
    "Big Legendary Box Test": "big",
    "Big Legendary Box": "big"
}

export {
    contracts,
    getOpenedNFTs,
    preOpenBox,
    getUserPaymentBalance,
    getBoxForSale,
    getUserPaymentAllowance,
    approveSpender,
    buyBox,
    openBox,
    getUserBoxCollection,
    lootBoxType
}
